<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue'

import { fetchPlatformsStore, usePlatformsData } from '@/services/platformsHomePageService'

import TradingContent from './TradingContent.vue'
import TradingMenu from './TradingMenu.vue'

const activeLink = ref({ link: 'hantecSocial', title: 'Hantec Social' })

const data = ref<any>()

onMounted(async () => {
  await fetchPlatformsStore()
  data.value = usePlatformsData().value
})

const activeData = computed(() => {
  return data?.value?.platforms_content?.filter(
    (item: any) => item.url === activeLink.value.link
  )[0]
})
</script>
<template>
  <div class="flex flex-col items-center justify-center w-full max-w-360">
    <div class="flex items-center justify-center w-full max-w-300">
      <div class="flex flex-col w-full">
        <div class="flex flex-col mt-20 mb-10 lg:mb-0 sm:mt-[160px]">
          <div
            class="lg:text-[40px] text-2xl font-bold text-center lg:leading-[40px] mx-[10px] leading-normal"
            v-html="data?.title"
          ></div>
          <div
            class="mt-[10px] text-lg lg:text-xl lg:leading-6 leading-[22px] sm:px-0 px-[10px] text-gray-500 text-center"
            v-html="data?.subtile"
          ></div>
        </div>
        <TradingMenu v-model="activeLink"></TradingMenu>

        <TradingContent :platformData="activeData" :activeLink="activeLink.link"></TradingContent>

        <div class="flex justify-center">
          <div class="w-11/12 lg:hidden h-[1px] bg-gray-350 mt-20 md:mt-40"></div>
        </div>
      </div>
    </div>
  </div>
</template>
